import TextField, { TextFieldProps } from "@mui/material/TextField";
import { ThemeProvider } from "@mui/material/styles";
import {
  GomakeOutlinedFieldClassName,
  getOutlinedFieldDirectionSx,
  getOutlinedFieldInputLabelProps,
  getOutlinedFieldInputProps,
  getOutlinedMultilineSx,
  getOutlinedSingleLineSx,
  outlinedFieldSx,
} from "./outlined-field-styles";
import { useOutlinedFieldTheme } from "./use-outlined-field-theme";

type GomakeOutlinedTextInputProps = TextFieldProps & {
  inputHeight?: number;
};

const GomakeOutlinedTextInput = ({
  sx,
  variant = "outlined",
  size = "small",
  fullWidth = true,
  className,
  InputLabelProps,
  inputProps,
  multiline,
  inputHeight,
  ...props
}: GomakeOutlinedTextInputProps) => {
  const { direction, theme } = useOutlinedFieldTheme();

  return (
    <ThemeProvider theme={theme}>
      <TextField
        fullWidth={fullWidth}
        variant={variant}
        size={size}
        dir={direction}
        multiline={multiline}
        className={
          className
            ? `${GomakeOutlinedFieldClassName} ${className}`
            : GomakeOutlinedFieldClassName
        }
        InputLabelProps={getOutlinedFieldInputLabelProps(
          direction,
          InputLabelProps
        )}
        inputProps={getOutlinedFieldInputProps(direction, inputProps)}
        sx={
          {
            ...outlinedFieldSx,
            ...(multiline
              ? {
                  ...getOutlinedFieldDirectionSx(direction, false),
                  ...getOutlinedMultilineSx(direction),
                }
              : getOutlinedSingleLineSx(inputHeight ?? 40, direction)),
            ...sx,
          } as any
        }
        {...props}
      />
    </ThemeProvider>
  );
};

export { GomakeOutlinedTextInput };
